import { __assign } from "tslib";
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Popper from '@material-ui/core/Popper';
import Fade from '@material-ui/core/Fade';
var useStyles = makeStyles(function (theme) { return ({
    paper: {
        border: '1px solid #B8B8B8',
        padding: theme.spacing(1),
        backgroundColor: theme.palette.background.paper
    }
}); });
export var CustomPopper = function (props) {
    var classes = useStyles();
    var open = Boolean(props.anchorEl);
    var id = open ? 'transitions-popper' : undefined;
    return (React.createElement(Popper, { id: id, open: open, anchorEl: props.anchorEl, transition: true }, function (_a) {
        var TransitionProps = _a.TransitionProps;
        return (React.createElement(Fade, __assign({}, TransitionProps, { timeout: 350 }),
            React.createElement("div", { className: classes.paper }, props.children)));
    }));
};
//# sourceMappingURL=Popper.js.map